<fa-icon
  *ngIf="help"
  icon="question-circle"
  [pTooltip]="help | translate"
  tooltipPosition="top"
  class="p-label-help"
  (click)="tooltipClicked.emit()"
></fa-icon>
<span *ngIf="info" class="info">{{ info | translate }}</span>
